export default "__VITE_ASSET__GEv20VAv__"